import { useState } from "react";

import { useNavigate } from "react-router-dom";

import {
  AppBar,
  Box,
  Button,
  Container,
  Icon,
  Paper,
  Stack,
  Toolbar,
  Typography,
} from "@mui/material";

import marker from "../../images/Markers.png";

import VerificaoStep from "./verificacao";
import IndentificaoStep from "./identificacao";
import pepIcon from "../../images/pepElaOutlined.png";
import EnderecoStep from "./endereco";
import LoginStep from "./login";
import { autocadastroPaciente } from "../../services/cadastroService";
import { dadosIniciais } from "./dadosIniciais";
import StepperCustom from "../../components/StepperCustom";
import ModalDialogs from "../../components/ModalDialogs";

const stepData = [
  { title: "Verificação" },
  { title: "Identificação" },
  { title: "Endereço" },
  { title: "Login" },
];

export default function PacienteCadastro(params) {
  const navigate = useNavigate();
  const [stepValue, setStepValue] = useState(0);
  const [dadosPaciente, setDadosPaciente] = useState(dadosIniciais);
  const [validacaoFalhou, setValidacaoFalhou] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);

  const nextStep = () => {
    setStepValue(stepValue + 1);
  };

  const handleClosedModalSuccess = () => {
    setOpenSuccess(false);
    navigate("/pacienteLogin");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validacaoFalhou && stepValue === 3) {
      alert("Preencha os campos corretamente");
      return;
    }

    if (stepValue >= 0 && stepValue < 3) {
      nextStep();
      return;
    }
    try {
      const success = await autocadastroPaciente(dadosPaciente);

      if (success) {
        setOpenSuccess(true);
      } else {
        alert("Erro ao realizar cadastro");
      }
    } catch (error) {
      console.error(error.message);
    }
  };

  return (
    <Box>
      <AppBar
        position="static"
        sx={{
          display: "flex",
          Width: "100%",
          height: "80px",
          justifyContent: "center",
        }}
      >
        <Container
          maxWidth="100vw"
          sx={{ backgroundColor: "#3E94C2", height: "80px", display: "flex" }}
        >
          <Toolbar>
            <Stack
              direction={"row"}
              width={"100%"}
              alignItems="center"
              height={{ xs: "40px", sm: "54px" }}
            >
              <Icon style={{ width: "auto", height: "100%" }}>
                <img
                  style={{ width: "auto", height: "100%" }}
                  src={pepIcon}
                  alt={"Icone Pep"}
                />
              </Icon>
            </Stack>
          </Toolbar>
        </Container>
      </AppBar>
      <Box
        sx={{
          display: "flex",
          direction: "column",
          justifyContent: "center",
          paddingBottom: "50px",
          transition: "all 0.2s ease",
        }}
        marginTop={{ xs: "30px", sm: "10vh" }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "32px",
            boxSizing: "border-box",
            transition: "all 0.2s ease",
          }}
          width={{ xs: "350px", sm: "580px", md: "810px" }}
        >
          <Typography color={"#063F5E"} fontSize={"26px"} fontWeight={600}>
            Cadastro
          </Typography>
          <Stack
            direction={"column"}
            alignItems={"center"}
            gap={"32px"}
            width={"100%"}
          >
            <StepperCustom stepData={stepData} currentStep={stepValue} />

            <Paper
              sx={{
                padding: "16px",
                borderRadius: "8px",
                boxShadow: "0px 1px 8px 0px rgba(0, 0, 0, 0.15)",
                width: "100%",
                boxSizing: "border-box",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "24px",
                  width: "100%",
                }}
              >
                <Typography
                  sx={{ fontWeight: 500, color: "#1E729F" }}
                  fontSize={{ xs: "20px", md: "22px" }}
                >
                  {stepValue === 0 && "Verificação de cadastro"}
                  {stepValue === 1 && "Dados pessoais e do paciente"}
                  {stepValue === 2 && "Endereço do paciente"}
                  {stepValue === 3 && "Dados login"}
                </Typography>

                <Stack
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: "#d3e3eb",
                    color: "#1e729f",
                    width: "100%",
                    maxWidth: "400px",
                    paddingRight: "8px",
                    borderRadius: "4px",
                  }}
                >
                  <img src={marker} alt="maker" />
                  <Typography fontSize={"14px"}>
                    Este marcador indica campos de preenchimento obrigatório.
                  </Typography>
                </Stack>
                <form onSubmit={handleSubmit}>
                  {stepValue === 0 && (
                    <VerificaoStep
                      nextStep={nextStep}
                      setDadosPaciente={setDadosPaciente}
                      dadosPaciente={dadosPaciente}
                    />
                  )}
                  {stepValue === 1 && (
                    <IndentificaoStep
                      setDadosPaciente={setDadosPaciente}
                      dadosPaciente={dadosPaciente}
                    />
                  )}
                  {stepValue === 2 && (
                    <EnderecoStep
                      setDadosPaciente={setDadosPaciente}
                      dadosPaciente={dadosPaciente}
                    />
                  )}
                  {stepValue === 3 && (
                    <LoginStep
                      setDadosPaciente={setDadosPaciente}
                      dadosPaciente={dadosPaciente}
                      setValidacaoFalhou={setValidacaoFalhou}
                    />
                  )}

                  <Stack
                    direction={"row"}
                    justifyContent={"space-between"}
                    mt={3}
                  >
                    <Button
                      variant="outlined"
                      sx={{ color: "#1E729F" }}
                      onClick={() => {
                        stepValue > 0 && setStepValue(stepValue - 1);
                      }}
                    >
                      {stepValue > 0 ? "Voltar" : "Cancelar"}
                    </Button>
                    <Button
                      variant="contained"
                      sx={{ backgroundColor: "#1E729F" }}
                      type="submit"
                    >
                      {stepValue === 3 ? "Enviar" : "Continuar"}
                    </Button>
                  </Stack>
                </form>
              </Box>
            </Paper>
          </Stack>
        </Box>
      </Box>
      <ModalDialogs
        open={openSuccess}
        onClose={() => handleClosedModalSuccess()}
        title="Sucesso"
        onActionPrimary={() => handleClosedModalSuccess()}
        primaryButtonText="Ir para login"
        modalType="success"
        body={
          <Box sx={{ width: { xs: "100%", sm: "400px" } }}>
            <Box> Cadastro realizado com sucesso</Box>
          </Box>
        }
      />
    </Box>
  );
}
